import { hasOwnProperty } from '../utils/typeUtils';
import { FieldValues, FormState } from 'react-hook-form';

export const genErrorIdFromLabel = (label: string) => `__${label}__field__`;

export const formFieldHasErrors = <T extends FieldValues>(
	fieldName: keyof T,
	formState: FormState<T>
) => hasOwnProperty(formState.errors, fieldName);
